import React from "react";
import styles from "./styles.module.scss";

export const Line: React.FC = () => {
  return <div className={styles.line} data-testid="line-jest" />;
};
